import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PopupLayout from '@appbase/templates/PopupLayout/PopupLayout.vue'
@Component({
  components: { PopupLayout },
})
export default class PopupViewMaster extends Vue {}
